import { render, staticRenderFns } from "./TrainingModules.vue?vue&type=template&id=7270b5d4&scoped=true&"
import script from "./TrainingModules.vue?vue&type=script&lang=ts&"
export * from "./TrainingModules.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingModules.vue?vue&type=style&index=0&id=7270b5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7270b5d4",
  null
  
)

export default component.exports